import './styles/ToggleSlider.scss';

interface Props {
    labelA: string, labelB: string,
    toggled: boolean, SetToggled: any,
    className?: string
}

const ToggleSlider: React.FC<Props> = ({ labelA, labelB, toggled, SetToggled, className }) => {
    return(
        <div className={'ToggleSlider ' + (className ? className : '')}>
            <button className='ToggleSlider-btn' onClick={() => SetToggled(!toggled)}>{labelA}</button>
            <button className='ToggleSlider-btn' onClick={() => SetToggled(!toggled)}>{labelB}</button>
            <button className={'ToggleSlider-mask ' + (toggled ? 'toggled' : '')} onClick={() => SetToggled(!toggled)}>{toggled ? labelB : labelA}</button>
        </div>
    )
}
export default ToggleSlider;